var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ValidCode disabled-select",style:(("width:" + _vm.width + "; height:" + _vm.height)),on:{"click":_vm.refreshCode}},_vm._l((_vm.codeList),function(item,index){return _c('span',{key:index,style:(_vm.getStyle(item))},[_vm._v(_vm._s(item.code))])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30a3edef","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidentify.vue
// module id = null
// module chunks = 